/**
 * Build image URL from storage path
 * Handles cases where path might already include /storage/ prefix
 * 
 * @param {string} imagePath - The image path from API
 * @param {string} storageBaseUrl - The base URL (without /api)
 * @returns {string|null} - Full image URL or null
 */
export const buildImageUrl = (imagePath, storageBaseUrl = null) => {
  if (!imagePath) return null;
  
  // If already a full URL, return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Get base URL if not provided
  if (!storageBaseUrl) {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    storageBaseUrl = API_BASE_URL.replace('/api', '');
  }
  
  // Remove trailing slash from base URL
  storageBaseUrl = storageBaseUrl.replace(/\/$/, '');
  
  // Check if path already starts with /storage/
  if (imagePath.startsWith('/storage/')) {
    return `${storageBaseUrl}${imagePath}`;
  }
  
  // Check if path starts with storage/ (without leading slash)
  if (imagePath.startsWith('storage/')) {
    return `${storageBaseUrl}/${imagePath}`;
  }
  
  // Default: add /storage/ prefix
  return `${storageBaseUrl}/storage/${imagePath}`;
};

/**
 * Build image URL using default API base URL
 * Shorthand version of buildImageUrl
 * 
 * @param {string} imagePath - The image path from API
 * @returns {string|null} - Full image URL or null
 */
export const getImageUrl = (imagePath) => {
  return buildImageUrl(imagePath);
};

export default { buildImageUrl, getImageUrl };
